import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  TranslationService
} from '@spartacus/core';
import { take, tap } from 'rxjs/operators';
import { UigExportComponent } from 'src/app/components/uig-export/uig-export.component';
import { CustomOrderHistoryRequest } from './custom-order-history.models';

@Injectable({
  providedIn: 'root',
})
export class CustomOrderHistoryService {
  constructor(
    private modalService: NgbModal,
    private httpClient: HttpClient,
    private endpoints: OccEndpointsService,
    private translation: TranslationService,
    private messageService: GlobalMessageService
  ) {}

  public printOrExportOrder(orderNumber: string): void {
    this.modalService.open(UigExportComponent, { centered: true }).result.then(
      (result) => {
        if (result === 'print') {
          window.print();
        } else {
          this.exportOrder(result, orderNumber);
        }
      },
      (reason) => {}
    );
  }

  public printOrExportOrderOverview(formData: CustomOrderHistoryRequest): void {
    this.modalService.open(UigExportComponent, { centered: true }).result.then(
      (result) => {
        if (result === 'print') {
          window.print();
        } else {
          this.exportOrderHistory(result, formData);
        }
      },
      (reason) => {}
    );
  }

  exportOrder(exportType: string, orderNumber: string) {
    const url = this.endpoints.buildUrl(
      'orderDetailDownload',
        {urlParams: { orderId: orderNumber }, queryParams: { selectExport: exportType }}
    );
    this.httpClient
      .get(url, { observe: 'body', responseType: 'blob' })
      .pipe(
        tap(
          (data) => {
            this.translation
              .translate('customOrderHistory.fileName.order')
              .pipe(take(1))
              .subscribe((fileName) => {
                var a = document.createElement('a');
                a.setAttribute('download', fileName + '.' + exportType);
                a.href = URL.createObjectURL(data);
                a.click();
              });
          },
          () => {
            this.translation
              .translate('customOrderHistory.errorExportOrder')
              .pipe(take(1))
              .subscribe((message) => {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              });
          }
        )
      )
      .subscribe((res) => {});
  }

  exportOrderHistory(
    selectExport: string,
    formData: CustomOrderHistoryRequest
  ) {
    this.translation
      .translate('customOrderHistory.downloadInfo')
      .pipe(take(1))
      .subscribe((message) => {
        this.messageService.add(message, GlobalMessageType.MSG_TYPE_INFO);
      });
    const url = this.endpoints.buildUrl('customOrderHistoryDownload', {queryParams: {
            selectExport,
        }} );
    var fileNameLoc =
      formData.type === 'REMAINS'
        ? 'customOrderHistory.fileName.remains'
        : 'customOrderHistory.fileName.overview';
    this.httpClient
      .post(url, formData, { observe: 'body', responseType: 'blob' })
      .pipe(
        tap(
          (data) => {
            this.translation
              .translate(fileNameLoc)
              .pipe(take(1))
              .subscribe((fileName) => {
                var a = document.createElement('a');
                a.setAttribute('download', fileName + '.' + selectExport);
                a.href = URL.createObjectURL(data);
                a.click();
              });
          },
          () => {
            this.translation
              .translate('customOrderHistory.errorExportOrder')
              .pipe(take(1))
              .subscribe((message) => {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              });
          }
        )
      )
      .subscribe((res) => {});
  }
}
